import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import {Rebuy} from '../_integrations/Rebuy';

function mountReact() {

  const container = document.getElementById('gcpRoot');

  if (!container) return;

  const reactVars = container.dataset.reactVars;
  const parsedReactVars = (reactVars) ? JSON.parse(reactVars) : {};

  const root      = createRoot(container);

  root.render((
    <App
      globalVars={parsedReactVars}
    />
  ));

}

Rebuy.init();

mountReact();
